import { render, staticRenderFns } from "./view-score.vue?vue&type=template&id=6797e8b6&scoped=true&"
import script from "./view-score.vue?vue&type=script&lang=js&"
export * from "./view-score.vue?vue&type=script&lang=js&"
import style0 from "./view-score.vue?vue&type=style&index=0&id=6797e8b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6797e8b6",
  null
  
)

export default component.exports